export const providers = [{"value": "4", "text": "Hotel Beds", "product_type": 0},{"value": "15", "text": "EasyJet Holidays", "product_type": 5},{"value": "11", "text": "Jet2Holidays", "product_type": 5},
{"value": "xce", "text": "Corendon Airlines", "product_type": 1},
{"value": "ezj", "text": "EasyJet", "product_type": 1},
{"value": "ewb", "text": "Eurowings", "product_type": 1},
{"value": "gmg", "text": "Gold Medal", "product_type": 1},
{"value": "jt2", "text": "Jet2", "product_type": 1},
{"value": "z0l", "text": "Norse", "product_type": 1},
{"value": "nor", "text": "Norwegian", "product_type": 1},
{"value": "frb", "text": "Ryanair", "product_type": 1},
{"value": "thf", "text": "TUI", "product_type": 1},
{"value": "w6l", "text": "Wizz Air", "product_type": 1}
]

export const get_provider_name = (provider_code) => {
    return providers.find(item => item.value === provider_code)?.text || "Unknown";
}
